import SiafLiteApiRepository from "../../external/siafLiteApi";
import encrypt from "../../utils/encrypt";

class MeuUsuarioService {
  constructor() {
    this.urlBase = "/painel-controle/meu-usuario";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  get() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }

  atualizar(id, usuario) {
    if (usuario.senha) {
      const senha = encrypt(usuario.senha);
      const confirmarSenha = encrypt(usuario.confirmarSenha);
      const body = { ...usuario, senha, confirmarSenha };
      return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
    }
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, usuario);
  }

  validarToken() {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/validar-token`).get();
  }

  trocarToken(empresaId) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/trocar-token/${empresaId}`
    ).get();
  }

  async validarPermissao(emailSenha, permission) {
    const basicAuth = encrypt(emailSenha);
    const body = { basicAuth, permission };
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/login-permissao`).post(
      body
    );
  }
}

export default MeuUsuarioService;
